module.exports = __webpack_public_path__ + "1cf3ae2435f441fcf5455b5c320e09be.png";